<div class="chart-container">
    <div>
        <button mat-icon-button matTooltip="Refrescar datos"
            (click)="loadTareas()"><mat-icon>refresh</mat-icon></button>
        <button mat-icon-button matTooltip="Seleccionar tarea"
            (click)="highlightNodeUnique()"><mat-icon>gps_fixed</mat-icon></button>
        <button mat-icon-button matTooltip="Alejar"
            (click)="orgChart.zoomOut({ by: 10, relative: true })"><mat-icon>zoom_out</mat-icon></button>
        <button mat-icon-button matTooltip="Acercar"
            (click)="orgChart.zoomIn({ by: 10, relative: true })"><mat-icon>zoom_in</mat-icon></button>
        <button mat-icon-button matTooltip="Reestablecer gr&aacute;fico" class="material-symbols-outlined"
            (click)="orgChart.resetPanAndZoom()">reset_focus</button>
    </div>

    @if (loading()) {
    <div class="loading-spinner">
        <mat-spinner></mat-spinner>
    </div>
    }
    <ngx-interactive-org-chart #orgChart layout="horizontal" [data]="orgChartData()" [minZoom]="0.3" [maxZoom]="2"
        [initialZoom]="01" [showMiniMap]="minMapVisible" [displayChildrenCount]="false" [themeOptions]="themeOptions()"
        style="display: block;" [ngStyle]="{ 'height': height }">
        <ng-template #nodeTemplate let-node="node" class="nodo" style="padding:0">
            <div class="context-menu" [matContextMenuTriggerFor]="contextMenu"
                [matContextMenuTriggerDisabled]="!(node?.data?.codigoParticipante == currentUser && node?.data?.estado === 2)"
                style="padding:var(--node-padding)">
                @if(node?.data?.tramite === null) {
                @if(node?.data?.tipo === 0 || node?.data?.tipo === 1 || node?.data?.tipo === 4) {
                <section class="graf__tarea" (click)="onClickNode(node)">
                    @if(node?.id == idNodeSelected){
                    <mat-icon class="material-symbols-outlined node-selected" >check_circle</mat-icon>
                    }
                    @if(node?.data?.codigoBuzon !== null){
                        <div [ngClass]="getClassForBuzonAvatar(node)">
                            <section class="graf__tarea1-thumbnail">
                                <span class="material-symbols-outlined buzon-mailbox-icon">
                                    markunread_mailbox
                                </span>
                            </section>
                            @if(node?.data?.codigoParticipante != null && node?.data?.foto !== "0"){
                                <section class="graf__tarea-thumbnail">
                                    <img [src]="node?.data?.foto" />
                                </section>
                            }
                        </div>
                    } @else{
                        @if(node?.data?.foto !== "0"){
                        <section class="graf__tarea-thumbnail">
                            <img [src]="node?.data?.foto" />
                        </section>
                        }@else{
                        <section class="graf__tarea-thumbnail">
                            <span class="material-symbols-outlined">
                                account_circle
                            </span>
                        </section>
                        }
                    }
                    <section class="graf__tarea-details" style="gap: 0.1rem">
                        @if(isBuzonNode(node)) {
                        <span class="graf__tarea-details-name buzon-line buzon-line-title">{{
                            node?.data?.nombreBuzon || node?.data?.participante
                            }}</span>
                        <span class="graf__tarea-details-position buzon-line">{{
                            node?.data?.departamento
                            }}</span>
                        @if(getBuzonClaimedName(node)) {
                        <span class="graf__tarea-details-position buzon-line buzon-line-claimed">{{
                            getBuzonClaimedName(node)
                            }}</span>
                        }
                        } @else {
                        <span class="graf__tarea-details-name"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">{{
                            node?.data?.departamento
                            }}</span>
                        <span class="graf__tarea-details-position">{{
                            node?.data?.participante
                            }}
                        </span>
                        }

                        @if(node?.data?.asignado){
                        <span class="graf__tarea-details-position">&rarr;{{
                            node?.data?.asignado
                            }}</span>
                        }
                        <span class="graf__tarea-details-date">{{
                            node?.data?.fecha
                            }}</span>
                        @if(node?.data?.tipo === 0){
                        <small
                            class="graf__tarea-details-status estado-color-{{node?.data?.estado}}">
                            @if(node?.data?.estado === 1 && node?.data?.leido === 0){
                                ASIGNADO
                            }@else{
                                {{node?.data?.estado|estadoTarea}}
                            }
                        </small>
                        }
                        @if(node?.data?.tipo === 1){
                        <small class="graf__tarea-details-status"><span class="material-symbols-outlined"
                                style="color: var(--text-primary); font-size: 1.2rem;">
                                copyright
                            </span></small>
                        }
                        @if(node?.data?.tipo === 4){
                        <small
                            class="graf__tarea-details-status estado-color-{{node?.data?.estado}}">
                            @if(node?.data?.estado === 1 && node?.data?.leido === 0){
                                ASIGNADO
                            }@else{
                                {{node?.data?.estado|estadoTarea}}
                            }
                        </small>
                        }

                    </section>
                    @if(node?.id === this.idTarea) {
                    <span class="material-symbols-outlined"
                        style="color: var(--mat-progress-spinner-active-indicator-color); width: 2rem;font-size: 2rem;">
                        gps_fixed
                    </span>
                    }
                </section>
                @if(node?.data?.remitentes?.length > 0){
                <section class="graf__tarea" (click)="onClickNode(node)">
                    @if(node?.id == idNodeSelected){
                    <mat-icon class="material-symbols-outlined node-selected">check_circle</mat-icon>
                    }
                    <section class="graf__tarea-thumbnail" style="height: 28px;">
                        <span class="material-symbols-outlined" style="font-size: 32px; color: var(--mat-progress-spinner-active-indicator-color);">
                            description
                        </span>
                    </section>
                    <section class="graf__tarea-details" style="gap: 0.1rem">
                        <span class="graf__tarea-details-position"
                            style="font-weight: 500; max-width: 250px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;"
                            matTooltip="{{node?.data?.asunto}}">{{
                            node?.data?.asunto
                            }}</span>
                        @for (destinatario of node?.data?.remitentes; track $index) {
                        <div class="graf__tarea-details-date" style="width: 200px;text-align: left;">
                            <span>{{destinatario.nombre}}</span>
                        </div>
                        }
                    </section>
                </section>
                }
                }

                <!--tareas-->
                @if(node?.data?.tipo === 2) {
                <section class="graf__tarea1" (click)="onClickNode(node)">
                    @if(node?.id == idNodeSelected){
                    <mat-icon class="material-symbols-outlined node-selected">check_circle</mat-icon>
                    }
                    @if(node?.data?.foto !== "0"){
                    <section class="graf__tarea1-thumbnail">
                        <img [src]="node?.data?.foto" />
                    </section>
                    }@else{
                    <section class="graf__tarea1-thumbnail">
                        <span class="material-symbols-outlined">
                            account_circle
                        </span>
                    </section>
                    }
                    <section class="graf__tarea1-details" style="gap: 0.1rem">
                        <span class="graf__tarea1-details-name"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">{{
                            node?.data?.departamento
                            }}</span>
                        <span class="graf__tarea1-details-position">{{
                            node?.data?.participante
                            }}</span>
                        <span class="graf__tarea1-details-date">{{
                            node?.data?.fecha
                            }}</span>
                        <span class="graf__tarea1-details-status subestado-color-{{node?.data?.subestado}}"></span>

                    </section>
                </section>
                }
                }

                <!--para ciudadadanos-->
                @if(node?.data?.tipo === 100) {
                <section class="graf__tarea1">
                    @if(node?.id == idNodeSelected){
                    <mat-icon class="material-symbols-outlined node-selected" >check_circle</mat-icon>
                    }
                    <section class="graf__tarea1-details" style="gap: 0.1rem">
                        <span class="graf__tarea-details-name"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">{{
                            node?.data?.departamento
                            }}</span>
                        <span class="graf__tarea1-details-name"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">{{
                            node?.data?.participante
                            }}</span>
                        <span class="graf__tarea1-details-position">{{
                            node?.data?.id
                            }}
                        </span>
                        <span class="graf__tarea1-details-date">{{
                            node?.data?.fecha
                            }}</span>

                    </section>
                    <small class="graf__tarea-details-status"><span class="material-symbols-outlined"
                            style="color: var(--text-primary); font-size: 1.5rem;">
                            campaign
                        </span></small>
                </section>
                }
                @if(node?.data?.tramite !== null || node?.data?.tipo === 5) {
                <section class="graf__tarea" (click)="onClickNode(node)">
                    @if(node?.id == idNodeSelected ){
                    <mat-icon class="material-symbols-outlined node-selected">check_circle</mat-icon>
                    }
                    <section class="graf__tarea-thumbnail">
                        <span class="material-symbols-outlined" style="color: var(--mat-progress-spinner-active-indicator-color);">
                            {{(node?.data?.tipo === -2)? 'article_shortcut': (node?.data?.tipo ===
                            5)?'insert_page_break':'description'}}
                        </span>
                    </section>
                    <section class="graf__tarea-details" style="gap: 0.1rem">
                        <span class="graf__tarea-details-name"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">{{
                            node?.data?.departamento
                            }}</span>
                        <span class="graf__tarea-details-position">{{
                            node?.data?.participante
                            }}</span>
                        <span class="graf__tarea-details-date">{{
                            node?.data?.fecha
                            }}</span>
                        <span class="graf__tarea1-details-name">{{
                            node?.data?.oficio
                            }}</span>
                        @if( node.data?.tramite != null ) {
                        <span class="graf__tarea-details-name">{{
                            node?.data?.tramite?.anio + ' - ' + node?.data?.tramite?.numero
                            }}</span>}
                        <span class="graf__tarea-details-name"
                            matTooltip="{{(node.data?.tipo  === 5)?node?.data?.asunto:node?.data?.tramite?.asunto}}"
                            style="display: inline-block;    max-width: 200px;    overflow: hidden;    text-overflow: ellipsis;    word-break: break-all;">
                            {{(node.data?.tipo === 5)?node?.data?.asunto:node?.data?.tramite?.asunto}}
                        </span>
                        @if(node?.data?.tipo !== 5){
                        <span class="graf__tarea-details-status subestado-color-{{node?.data?.subestado}}"></span>
                        }

                    </section>
                    @if(node?.id === this.idTarea) {
                    <span class="material-symbols-outlined"
                        style="color: var(--mat-progress-spinner-active-indicator-color); width: 2rem;font-size: 2rem;right: 16px;bottom: 26px; position: absolute;">
                        gps_fixed
                    </span>
                    }

                </section>
                }
            </div>
            <mat-menu #contextMenu style="width: 300px;">
                <button mat-menu-item (click)="manageAlcance(node?.data.id)">
                    <mat-icon>account_tree</mat-icon>
                    Generar Alcance Documento
                </button>
            </mat-menu>
        </ng-template>
    </ngx-interactive-org-chart>
</div>